// css
import '../css-scss/eshop.scss';

// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';
//import './configureTurbolinks';



// WEBPACK FOOTER //
// ./fe/web-eshop/src/js/index-eshop.js